// extracted by mini-css-extract-plugin
export default {"toggleContainer":"ModerateOnboarding_toggleContainer__4TGQX","totExpiryDatePicker":"ModerateOnboarding_totExpiryDatePicker__ILaG-"};